module.exports = __webpack_public_path__ + "img/a3-s17.48ecc7ca.jpg";